"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddActivityFlagQueueBodySchema = exports.AddActivityFlagDetailsSchema = exports.AddTokenIdQueueBodySchema = exports.addBlockchainModelSchema = exports.addActivitiesToBlockchainSchema = exports.addTokenToBlockchainSchema = void 0;
const zod_1 = require("zod");
const token_1 = require("../misc/token");
const token_2 = require("../misc/token");
const activity_1 = require("../lib/activity");
exports.addTokenToBlockchainSchema = zod_1.z.object({
    type: zod_1.z.literal("tokens"),
    tokens: zod_1.z.array(zod_1.z.object({
        type: token_2.tokenTypesSchema,
        externalIds: token_1.ExternalIdsSchema.omit({ timestamp: true }),
        hash: zod_1.z.string()
    }))
});
exports.addActivitiesToBlockchainSchema = zod_1.z.object({
    type: zod_1.z.literal("activities"),
    activities: zod_1.z.object({
        tokenId: zod_1.z.string().optional(),
        externalIds: token_1.ExternalIdsSchema.omit({ timestamp: true }),
        activities: zod_1.z.array(zod_1.z.object({
            bucketUUID: zod_1.z.string(),
            activityUUID: zod_1.z.string(),
            type: zod_1.z.string(),
            hash: zod_1.z.string()
        }))
    })
});
exports.addBlockchainModelSchema = zod_1.z.union([exports.addTokenToBlockchainSchema, exports.addActivitiesToBlockchainSchema]);
exports.AddTokenIdQueueBodySchema = zod_1.z.object({
    auth: zod_1.z.string(),
    scope: zod_1.z.literal("blockchain"),
    externalIds: token_1.ExternalIdsSchema,
    type: zod_1.z.literal(activity_1.ActivityTypeSchema.enum.addTokenId),
    details: activity_1.AddTokenIdDetailSchema,
    createdAt: zod_1.z.string(),
});
exports.AddActivityFlagDetailsSchema = zod_1.z.object({
    storedBlockchain: zod_1.z.boolean(),
    transactionId: zod_1.z.string(),
    transactionTime: zod_1.z.string()
});
exports.AddActivityFlagQueueBodySchema = zod_1.z.object({
    auth: zod_1.z.string(),
    scope: zod_1.z.literal("blockchain"),
    externalds: token_1.ExternalIdsSchema.omit({ timestamp: true }),
    type: activity_1.ActivityTypeSchema,
    details: exports.AddActivityFlagDetailsSchema,
    activityDetails: zod_1.z.object({
        bucketUUID: zod_1.z.string(),
        activityUUID: zod_1.z.string(),
        type: zod_1.z.string(),
        hash: zod_1.z.string()
    })
});
